export default "__VITE_ASSET__yDiOmvzF__"